import type { ObjectPaths } from '@lokalise/ui/ts-utils';

import get from '../../utils/object/get';
import type { Theme } from '../types';
import fromTheme from './fromTheme';

const typography = <P extends ObjectPaths<Theme['typography']>>(typographyPath: P) =>
    fromTheme((theme) => get(typographyPath, theme.typography));

export default typography;
